import React, { memo, useState, useRef, useEffect } from 'react'

// icons : feather
import FeatherIcon from 'feather-icons-react';

// unique id
import uuid from 'react-uuid'

function FormImages(props) {
    // props
    const { productImages, getImagesToBeSaved } = props

    // refs
    const addImgInputRef = useRef(null)

    // states
    const [selectedImages, setSelectedImages] = useState([])
    const [imagesToBeDeleted, setImagesToBeDeleted] = useState([])

    // setting default images
    useEffect(() => {
        const allImages = []
        // main image
        if (productImages?.main_thumb?.small) {
            allImages.push({
                id: uuid(),
                fullItem: productImages,
                src: productImages.main_thumb.small
            })
        }

        // multiple iamges
        if (productImages?.other?.small) {
            const images = productImages.other.small

            images.forEach(imageItem => {
                const id = uuid()
                allImages.push({
                    id,
                    fullItem: imageItem,
                    src: imageItem
                })
            })
        }

        // saving iamges
        setSelectedImages(allImages)
    }, [productImages])

    // add image change
    const handleAddImageChange = ev => {
        const inpVal = ev.target.value
        // let value = ev.target.value;
        let file = ev.target.files;

        let newArray = []
        for (const key of file) {
            // initializing FileReader
            let reader = new FileReader();

            // reading data from the file
            reader.readAsDataURL(key);

            // on load
            reader.onload = function () {
                newArray.push({
                    id: uuid(),
                    src: reader.result,
                    value: inpVal
                })
            };
            // on error
            reader.onerror = function () {
                console.log("error while getting file info ", reader.error);
            };
        }

        // setting the newly selected image to the state
        setTimeout(() => {
            setSelectedImages([
                ...selectedImages,
                ...newArray
            ])


            // sending data back to parent
            getImagesToBeSaved && getImagesToBeSaved(newArray[0].value)


            // resetting the add image input
            addImgInputRef.current.value = ""
        }, 200);
    }

    // delete image
    const handleDeleteSelectedImage = (ev, id, imgSrc) => {
        ev.preventDefault()

        const filteredImgSrc = imgSrc.split("/")
        const actualPath = filteredImgSrc[filteredImgSrc.length - 1]

        // let COPY_selectedImages = [...selectedImages]

        // updating values
        // let updatedSelectedImages = COPY_selectedImages.filter(item => (item.id !== id) && item)

        // setting the updated selected image to the state
        // setSelectedImages(updatedSelectedImages)

        // setting images to be deleted
        setImagesToBeDeleted([...imagesToBeDeleted, {
            id,
            actualPath
        }])
    }

    // handle restore deleted image
    const handleRestoreDeletedImg = (ev, id) => {
        ev.preventDefault()
        const updatedData = imagesToBeDeleted.filter(item => item.id !== id)
        setImagesToBeDeleted(updatedData)
    }

    return (
        <React.Fragment>
            <div className="prods-selected-images">
                <div className="psi-inner d-flex flex-wrap">
                    {
                        selectedImages?.length ? selectedImages.map((item, index) => {
                            return (
                                <div key={item.id} data-id={item.id} className={`img-block position-relative ${imagesToBeDeleted.find(el => el.id === item.id) ? "to-be-deleted" : ""}`}>
                                    <div className="inner h-100 d-flex align-items-center justify-content-center">
                                        <img src={item.src} alt={`product-img-${index}`} className="img-fluid img-fluid-height" />
                                    </div>

                                    {/* options */}
                                    <div className={`options position-absolute h-100 w-100 d-flex flex-wrap`}>
                                        {
                                            imagesToBeDeleted.find(el => el.id === item.id) ? (
                                                <React.Fragment>
                                                    {/* removed text */}
                                                    <div className="removed-text st-fs-13 st-fw-600 w-100 align-self-center text-center">
                                                        <p>Removed</p>
                                                    </div>

                                                    {/* restore */}
                                                    <div className="restore-text w-100 align-self-end d-flex justify-content-center mb-1">
                                                        <a href="/" className="d-flex text-decoration-none st-text-primary st-fs-13 st-fw-600"
                                                            onClick={ev => handleRestoreDeletedImg(ev, item.id)}>
                                                            <FeatherIcon
                                                                icon="corner-up-left"
                                                                size="12"
                                                                className="icon position-relative me-1"
                                                                style={{ top: 3 }}
                                                            />
                                                            <span>Restore</span>
                                                        </a>
                                                    </div>
                                                </React.Fragment>
                                            ) : (
                                                // delete
                                                <div className="delete-icon ms-auto">
                                                    <a href="/"
                                                        className="delete st-round-btn st-btn-xs d-flex align-items-center justify-content-center"
                                                        title="Delete"
                                                        onClick={ev => handleDeleteSelectedImage(ev, item.id, item.src)}>
                                                        <FeatherIcon
                                                            icon="trash-2"
                                                            size="14"
                                                            className="icon" />
                                                    </a>
                                                </div>

                                            )
                                        }
                                    </div>
                                </div>
                            )
                        }) : null
                    }

                    <label className="add-img cursor-pointer">
                        <input
                            type="file"
                            accept="image/png, image/gif, image/jpeg"
                            hidden
                            multiple
                            ref={addImgInputRef}
                            onChange={handleAddImageChange} />
                        <span className="d-flex flex-column align-items-center justify-content-center h-100 w-100 inner">
                            {/* box */}
                            <div className="icon-box d-flex align-items-center justify-content-center">
                                <FeatherIcon
                                    icon="plus"
                                    size="20"
                                    className="icon st-text-primary position-relative" />
                            </div>
                            {/* text */}
                            <p className="st-fs-13 st-fw-600 mt-2 st-text-primary">Upload Image</p>
                        </span>
                    </label>

                    {
                        !selectedImages?.length ? (
                            <React.Fragment>
                                {/* test image */}
                                <label className="test-img cursor-pointer">
                                    <span className="d-flex flex-column align-items-center justify-content-center h-100 w-100 inner">
                                        {/* box */}
                                        <div className="img-box d-flex align-items-center justify-content-center">

                                        </div>
                                        {/* text */}
                                        <p className="text st-fs-12 st-fw-600 mt-2">Main Image</p>
                                    </span>
                                </label>

                                {/* test image */}
                                <label className="test-img cursor-pointer">
                                    <span className="d-flex flex-column align-items-center justify-content-center h-100 w-100 inner">
                                        {/* box */}
                                        <div className="img-box d-flex align-items-center justify-content-center">

                                        </div>
                                        {/* text */}
                                        <p className="text st-fs-12 st-fw-600 mt-2">Different Angles</p>
                                    </span>
                                </label>

                                {/* test image */}
                                <label className="test-img cursor-pointer">
                                    <span className="d-flex flex-column align-items-center justify-content-center h-100 w-100 inner">
                                        {/* box */}
                                        <div className="img-box d-flex align-items-center justify-content-center">

                                        </div>
                                        {/* text */}
                                        <p className="text st-fs-12 st-fw-600 mt-2">Close-Up</p>
                                    </span>
                                </label>

                                {/* test image */}
                                <label className="test-img cursor-pointer">
                                    <span className="d-flex flex-column align-items-center justify-content-center h-100 w-100 inner">
                                        {/* box */}
                                        <div className="img-box d-flex align-items-center justify-content-center">

                                        </div>
                                        {/* text */}
                                        <p className="text st-fs-12 st-fw-600 mt-2">In Use</p>
                                    </span>
                                </label>

                                {/* test image */}
                                <label className="test-img cursor-pointer">
                                    <span className="d-flex flex-column align-items-center justify-content-center h-100 w-100 inner">
                                        {/* box */}
                                        <div className="img-box d-flex align-items-center justify-content-center">

                                        </div>
                                        {/* text */}
                                        <p className="text st-fs-12 st-fw-600 mt-2">Styles</p>
                                    </span>
                                </label>
                            </React.Fragment>
                        ) : null
                    }
                </div>
            </div>
        </React.Fragment >
    )
}


export default memo(FormImages)